/**
 * ATTENTION! This file is auto-generated for the 'mws' module.
 * Vite plugin placed is here: packages/platform/server/rpc-generator/generator.ts
 * Any manual changes will be overwritten on the next build.
*/

import { makeRepositoryProxy } from '@ayocore/platform/server/rpc/makeRepositoryProxy';
import { makeFunctionProxy } from '@ayocore/platform/server/rpc/makeFunctionProxy';
import type { RpcFunctionClient } from '@ayocore/platform/server/rpc/types';
import type { StageRepository } from '../server/repositories/StageRepository';
import type { AreaCodeRepository } from '../server/repositories/AreaCodeRepository';
import type { DirectionRepository } from '../server/repositories/DirectionRepository';
import type { WorkCategoryRepository } from '../server/repositories/WorkCategoryRepository';
import type { WorkTypeRepository } from '../server/repositories/WorkTypeRepository';
import type { InspectionTemplateRepository } from '../server/repositories/InspectionTemplateRepository';
import type { PhotoNameTemplateRepository } from '../server/repositories/PhotoNameTemplateRepository';
import type { ProjectTypeRepository } from '../server/repositories/ProjectTypeRepository';
import type { ProjectRepository } from '../server/repositories/ProjectRepository';
import type { CustomerRepository } from '../server/repositories/CustomerRepository';
import type { CustomerProjectRepository } from '../server/repositories/CustomerProjectRepository';
import type { GrandBlockRepository } from '../server/repositories/GrandBlockRepository';
import type { DeckRepository } from '../server/repositories/DeckRepository';
import type { SectionRepository } from '../server/repositories/SectionRepository';
import type { ItpItemRepository } from '../server/repositories/ItpItemRepository';
import type { ItpChecklistItemRepository } from '../server/repositories/ItpChecklistItemRepository';
import type { DrawingRepository } from '../server/repositories/DrawingRepository';
import type { ElectricalSystemRepository } from '../server/repositories/ElectricalSystemRepository';
import type { ZoneRepository } from '../server/repositories/ZoneRepository';
import type { CompartmentRepository } from '../server/repositories/CompartmentRepository';
import type { EquipmentRepository } from '../server/repositories/EquipmentRepository';
import type { ElectricalCableRepository } from '../server/repositories/ElectricalCableRepository';
import type { PipingSystemRepository } from '../server/repositories/PipingSystemRepository';
import type { PipingSegmentRepository } from '../server/repositories/PipingSegmentRepository';
import type { PipingSpoolRepository } from '../server/repositories/PipingSpoolRepository';
import type { PipingTrackingRepository } from '../server/repositories/PipingTrackingRepository';
import type { ElectroTrackingRepository } from '../server/repositories/ElectroTrackingRepository';
import type { MechEntityTypeRepository } from '../server/repositories/MechEntityTypeRepository';
import type { MechGroupRepository } from '../server/repositories/MechGroupRepository';
import type { MechEntityRepository } from '../server/repositories/MechEntityRepository';
import type { MechTrackingRepository } from '../server/repositories/MechTrackingRepository';
import type { RollingPlanVersionRepository } from '../server/repositories/RollingPlanVersionRepository';
import type { RollingPlanRawRepository } from '../server/repositories/RollingPlanRawRepository';
import type { RollingPlanStageRepository } from '../server/repositories/RollingPlanStageRepository';
import type { ScheduleEntryRepository } from '../server/repositories/ScheduleEntryRepository';
import type { InspectionRepository } from '../server/repositories/InspectionRepository';
import type { InspectionSectionRepository } from '../server/repositories/InspectionSectionRepository';
import type { InspectionCableRepository } from '../server/repositories/InspectionCableRepository';
import type { InspectionSurveyorRepository } from '../server/repositories/InspectionSurveyorRepository';
import type { InspectionSystemRepository } from '../server/repositories/InspectionSystemRepository';
import type { InspectionEquipmentRepository } from '../server/repositories/InspectionEquipmentRepository';
import type { InspectionPipingSystemRepository } from '../server/repositories/InspectionPipingSystemRepository';
import type { InspectionPipingSegmentRepository } from '../server/repositories/InspectionPipingSegmentRepository';
import type { InspectionPipingSpoolRepository } from '../server/repositories/InspectionPipingSpoolRepository';
import type { InspectionMechEntityRepository } from '../server/repositories/InspectionMechEntityRepository';
import type { InspectionDeckRepository } from '../server/repositories/InspectionDeckRepository';
import type { InspectionCompartmentRepository } from '../server/repositories/InspectionCompartmentRepository';
import type { InspectionDrawingRepository } from '../server/repositories/InspectionDrawingRepository';
import type { NcrRepository } from '../server/repositories/NcrRepository';
import type { NcrResponsibleRepository } from '../server/repositories/NcrResponsibleRepository';
import type { ProtocolRepository } from '../server/repositories/ProtocolRepository';
import type { AcceptanceActRepository } from '../server/repositories/AcceptanceActRepository';
import type { CertificateRepository } from '../server/repositories/CertificateRepository';
import type { CertificateObjectRepository } from '../server/repositories/CertificateObjectRepository';
import type { ReportingWeekRepository } from '../server/repositories/ReportingWeekRepository';
import type { ReportRepository } from '../server/repositories/ReportRepository';
import type { ReportPublicationRepository } from '../server/repositories/ReportPublicationRepository';
import type { RequestImportRepository } from '../server/repositories/RequestImportRepository';
import type { PlanImportRepository } from '../server/repositories/PlanImportRepository';
import type { ShipyardWeekPlanRepository } from '../server/repositories/ShipyardWeekPlanRepository';
import type { RpImportRepository } from '../server/repositories/RpImportRepository';
import type { RpSnapshotRepository } from '../server/repositories/RpSnapshotRepository';
import type { RpPlanRepository } from '../server/repositories/RpPlanRepository';
import type { RpRowRepository } from '../server/repositories/RpRowRepository';
import type { RpTranslationRepository } from '../server/repositories/RpTranslationRepository';

// Terminal methods configuration
const TERMINAL_METHODS = ["create","update","findById","deleteById","fetch","count","aggregate","aggregateBy","countGroups","meta","getInstance","columns","filters"];

type StageRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<StageRepository>;
export function useStageRepository(): StageRepositoryClient { return makeRepositoryProxy<StageRepositoryClient>('mws::StageRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useStageRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const stageRepository = useStageRepository();

type AreaCodeRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<AreaCodeRepository>;
export function useAreaCodeRepository(): AreaCodeRepositoryClient { return makeRepositoryProxy<AreaCodeRepositoryClient>('mws::AreaCodeRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useAreaCodeRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const areaCodeRepository = useAreaCodeRepository();

type DirectionRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<DirectionRepository>;
export function useDirectionRepository(): DirectionRepositoryClient { return makeRepositoryProxy<DirectionRepositoryClient>('mws::DirectionRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useDirectionRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const directionRepository = useDirectionRepository();

type WorkCategoryRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<WorkCategoryRepository>;
export function useWorkCategoryRepository(): WorkCategoryRepositoryClient { return makeRepositoryProxy<WorkCategoryRepositoryClient>('mws::WorkCategoryRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useWorkCategoryRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const workCategoryRepository = useWorkCategoryRepository();

type WorkTypeRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<WorkTypeRepository>;
export function useWorkTypeRepository(): WorkTypeRepositoryClient { return makeRepositoryProxy<WorkTypeRepositoryClient>('mws::WorkTypeRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useWorkTypeRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const workTypeRepository = useWorkTypeRepository();

type InspectionTemplateRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<InspectionTemplateRepository>;
export function useInspectionTemplateRepository(): InspectionTemplateRepositoryClient { return makeRepositoryProxy<InspectionTemplateRepositoryClient>('mws::InspectionTemplateRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useInspectionTemplateRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const inspectionTemplateRepository = useInspectionTemplateRepository();

type PhotoNameTemplateRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<PhotoNameTemplateRepository>;
export function usePhotoNameTemplateRepository(): PhotoNameTemplateRepositoryClient { return makeRepositoryProxy<PhotoNameTemplateRepositoryClient>('mws::PhotoNameTemplateRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте usePhotoNameTemplateRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const photoNameTemplateRepository = usePhotoNameTemplateRepository();

type ProjectTypeRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<ProjectTypeRepository>;
export function useProjectTypeRepository(): ProjectTypeRepositoryClient { return makeRepositoryProxy<ProjectTypeRepositoryClient>('mws::ProjectTypeRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useProjectTypeRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const projectTypeRepository = useProjectTypeRepository();

type ProjectRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<ProjectRepository>;
export function useProjectRepository(): ProjectRepositoryClient { return makeRepositoryProxy<ProjectRepositoryClient>('mws::ProjectRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useProjectRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const projectRepository = useProjectRepository();

type CustomerRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<CustomerRepository>;
export function useCustomerRepository(): CustomerRepositoryClient { return makeRepositoryProxy<CustomerRepositoryClient>('mws::CustomerRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useCustomerRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const customerRepository = useCustomerRepository();

type CustomerProjectRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<CustomerProjectRepository>;
export function useCustomerProjectRepository(): CustomerProjectRepositoryClient { return makeRepositoryProxy<CustomerProjectRepositoryClient>('mws::CustomerProjectRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useCustomerProjectRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const customerProjectRepository = useCustomerProjectRepository();

type GrandBlockRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<GrandBlockRepository>;
export function useGrandBlockRepository(): GrandBlockRepositoryClient { return makeRepositoryProxy<GrandBlockRepositoryClient>('mws::GrandBlockRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useGrandBlockRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const grandBlockRepository = useGrandBlockRepository();

type DeckRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<DeckRepository>;
export function useDeckRepository(): DeckRepositoryClient { return makeRepositoryProxy<DeckRepositoryClient>('mws::DeckRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useDeckRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const deckRepository = useDeckRepository();

type SectionRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<SectionRepository>;
export function useSectionRepository(): SectionRepositoryClient { return makeRepositoryProxy<SectionRepositoryClient>('mws::SectionRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useSectionRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const sectionRepository = useSectionRepository();

type ItpItemRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<ItpItemRepository>;
export function useItpItemRepository(): ItpItemRepositoryClient { return makeRepositoryProxy<ItpItemRepositoryClient>('mws::ItpItemRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useItpItemRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const itpItemRepository = useItpItemRepository();

type ItpChecklistItemRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<ItpChecklistItemRepository>;
export function useItpChecklistItemRepository(): ItpChecklistItemRepositoryClient { return makeRepositoryProxy<ItpChecklistItemRepositoryClient>('mws::ItpChecklistItemRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useItpChecklistItemRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const itpChecklistItemRepository = useItpChecklistItemRepository();

type DrawingRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<DrawingRepository>;
export function useDrawingRepository(): DrawingRepositoryClient { return makeRepositoryProxy<DrawingRepositoryClient>('mws::DrawingRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useDrawingRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const drawingRepository = useDrawingRepository();

type ElectricalSystemRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<ElectricalSystemRepository>;
export function useElectricalSystemRepository(): ElectricalSystemRepositoryClient { return makeRepositoryProxy<ElectricalSystemRepositoryClient>('mws::ElectricalSystemRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useElectricalSystemRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const electricalSystemRepository = useElectricalSystemRepository();

type ZoneRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<ZoneRepository>;
export function useZoneRepository(): ZoneRepositoryClient { return makeRepositoryProxy<ZoneRepositoryClient>('mws::ZoneRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useZoneRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const zoneRepository = useZoneRepository();

type CompartmentRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<CompartmentRepository>;
export function useCompartmentRepository(): CompartmentRepositoryClient { return makeRepositoryProxy<CompartmentRepositoryClient>('mws::CompartmentRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useCompartmentRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const compartmentRepository = useCompartmentRepository();

type EquipmentRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<EquipmentRepository>;
export function useEquipmentRepository(): EquipmentRepositoryClient { return makeRepositoryProxy<EquipmentRepositoryClient>('mws::EquipmentRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useEquipmentRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const equipmentRepository = useEquipmentRepository();

type ElectricalCableRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<ElectricalCableRepository>;
export function useElectricalCableRepository(): ElectricalCableRepositoryClient { return makeRepositoryProxy<ElectricalCableRepositoryClient>('mws::ElectricalCableRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useElectricalCableRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const electricalCableRepository = useElectricalCableRepository();

type PipingSystemRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<PipingSystemRepository>;
export function usePipingSystemRepository(): PipingSystemRepositoryClient { return makeRepositoryProxy<PipingSystemRepositoryClient>('mws::PipingSystemRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте usePipingSystemRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const pipingSystemRepository = usePipingSystemRepository();

type PipingSegmentRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<PipingSegmentRepository>;
export function usePipingSegmentRepository(): PipingSegmentRepositoryClient { return makeRepositoryProxy<PipingSegmentRepositoryClient>('mws::PipingSegmentRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте usePipingSegmentRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const pipingSegmentRepository = usePipingSegmentRepository();

type PipingSpoolRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<PipingSpoolRepository>;
export function usePipingSpoolRepository(): PipingSpoolRepositoryClient { return makeRepositoryProxy<PipingSpoolRepositoryClient>('mws::PipingSpoolRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте usePipingSpoolRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const pipingSpoolRepository = usePipingSpoolRepository();

type PipingTrackingRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<PipingTrackingRepository>;
export function usePipingTrackingRepository(): PipingTrackingRepositoryClient { return makeRepositoryProxy<PipingTrackingRepositoryClient>('mws::PipingTrackingRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте usePipingTrackingRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const pipingTrackingRepository = usePipingTrackingRepository();

type ElectroTrackingRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<ElectroTrackingRepository>;
export function useElectroTrackingRepository(): ElectroTrackingRepositoryClient { return makeRepositoryProxy<ElectroTrackingRepositoryClient>('mws::ElectroTrackingRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useElectroTrackingRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const electroTrackingRepository = useElectroTrackingRepository();

type MechEntityTypeRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<MechEntityTypeRepository>;
export function useMechEntityTypeRepository(): MechEntityTypeRepositoryClient { return makeRepositoryProxy<MechEntityTypeRepositoryClient>('mws::MechEntityTypeRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useMechEntityTypeRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const mechEntityTypeRepository = useMechEntityTypeRepository();

type MechGroupRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<MechGroupRepository>;
export function useMechGroupRepository(): MechGroupRepositoryClient { return makeRepositoryProxy<MechGroupRepositoryClient>('mws::MechGroupRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useMechGroupRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const mechGroupRepository = useMechGroupRepository();

type MechEntityRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<MechEntityRepository>;
export function useMechEntityRepository(): MechEntityRepositoryClient { return makeRepositoryProxy<MechEntityRepositoryClient>('mws::MechEntityRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useMechEntityRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const mechEntityRepository = useMechEntityRepository();

type MechTrackingRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<MechTrackingRepository>;
export function useMechTrackingRepository(): MechTrackingRepositoryClient { return makeRepositoryProxy<MechTrackingRepositoryClient>('mws::MechTrackingRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useMechTrackingRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const mechTrackingRepository = useMechTrackingRepository();

type RollingPlanVersionRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<RollingPlanVersionRepository>;
export function useRollingPlanVersionRepository(): RollingPlanVersionRepositoryClient { return makeRepositoryProxy<RollingPlanVersionRepositoryClient>('mws::RollingPlanVersionRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useRollingPlanVersionRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const rollingPlanVersionRepository = useRollingPlanVersionRepository();

type RollingPlanRawRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<RollingPlanRawRepository>;
export function useRollingPlanRawRepository(): RollingPlanRawRepositoryClient { return makeRepositoryProxy<RollingPlanRawRepositoryClient>('mws::RollingPlanRawRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useRollingPlanRawRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const rollingPlanRawRepository = useRollingPlanRawRepository();

type RollingPlanStageRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<RollingPlanStageRepository>;
export function useRollingPlanStageRepository(): RollingPlanStageRepositoryClient { return makeRepositoryProxy<RollingPlanStageRepositoryClient>('mws::RollingPlanStageRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useRollingPlanStageRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const rollingPlanStageRepository = useRollingPlanStageRepository();

type ScheduleEntryRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<ScheduleEntryRepository>;
export function useScheduleEntryRepository(): ScheduleEntryRepositoryClient { return makeRepositoryProxy<ScheduleEntryRepositoryClient>('mws::ScheduleEntryRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useScheduleEntryRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const scheduleEntryRepository = useScheduleEntryRepository();

type InspectionRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<InspectionRepository>;
export function useInspectionRepository(): InspectionRepositoryClient { return makeRepositoryProxy<InspectionRepositoryClient>('mws::InspectionRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useInspectionRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const inspectionRepository = useInspectionRepository();

type InspectionSectionRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<InspectionSectionRepository>;
export function useInspectionSectionRepository(): InspectionSectionRepositoryClient { return makeRepositoryProxy<InspectionSectionRepositoryClient>('mws::InspectionSectionRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useInspectionSectionRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const inspectionSectionRepository = useInspectionSectionRepository();

type InspectionCableRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<InspectionCableRepository>;
export function useInspectionCableRepository(): InspectionCableRepositoryClient { return makeRepositoryProxy<InspectionCableRepositoryClient>('mws::InspectionCableRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useInspectionCableRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const inspectionCableRepository = useInspectionCableRepository();

type InspectionSurveyorRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<InspectionSurveyorRepository>;
export function useInspectionSurveyorRepository(): InspectionSurveyorRepositoryClient { return makeRepositoryProxy<InspectionSurveyorRepositoryClient>('mws::InspectionSurveyorRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useInspectionSurveyorRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const inspectionSurveyorRepository = useInspectionSurveyorRepository();

type InspectionSystemRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<InspectionSystemRepository>;
export function useInspectionSystemRepository(): InspectionSystemRepositoryClient { return makeRepositoryProxy<InspectionSystemRepositoryClient>('mws::InspectionSystemRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useInspectionSystemRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const inspectionSystemRepository = useInspectionSystemRepository();

type InspectionEquipmentRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<InspectionEquipmentRepository>;
export function useInspectionEquipmentRepository(): InspectionEquipmentRepositoryClient { return makeRepositoryProxy<InspectionEquipmentRepositoryClient>('mws::InspectionEquipmentRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useInspectionEquipmentRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const inspectionEquipmentRepository = useInspectionEquipmentRepository();

type InspectionPipingSystemRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<InspectionPipingSystemRepository>;
export function useInspectionPipingSystemRepository(): InspectionPipingSystemRepositoryClient { return makeRepositoryProxy<InspectionPipingSystemRepositoryClient>('mws::InspectionPipingSystemRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useInspectionPipingSystemRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const inspectionPipingSystemRepository = useInspectionPipingSystemRepository();

type InspectionPipingSegmentRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<InspectionPipingSegmentRepository>;
export function useInspectionPipingSegmentRepository(): InspectionPipingSegmentRepositoryClient { return makeRepositoryProxy<InspectionPipingSegmentRepositoryClient>('mws::InspectionPipingSegmentRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useInspectionPipingSegmentRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const inspectionPipingSegmentRepository = useInspectionPipingSegmentRepository();

type InspectionPipingSpoolRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<InspectionPipingSpoolRepository>;
export function useInspectionPipingSpoolRepository(): InspectionPipingSpoolRepositoryClient { return makeRepositoryProxy<InspectionPipingSpoolRepositoryClient>('mws::InspectionPipingSpoolRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useInspectionPipingSpoolRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const inspectionPipingSpoolRepository = useInspectionPipingSpoolRepository();

type InspectionMechEntityRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<InspectionMechEntityRepository>;
export function useInspectionMechEntityRepository(): InspectionMechEntityRepositoryClient { return makeRepositoryProxy<InspectionMechEntityRepositoryClient>('mws::InspectionMechEntityRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useInspectionMechEntityRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const inspectionMechEntityRepository = useInspectionMechEntityRepository();

type InspectionDeckRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<InspectionDeckRepository>;
export function useInspectionDeckRepository(): InspectionDeckRepositoryClient { return makeRepositoryProxy<InspectionDeckRepositoryClient>('mws::InspectionDeckRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useInspectionDeckRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const inspectionDeckRepository = useInspectionDeckRepository();

type InspectionCompartmentRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<InspectionCompartmentRepository>;
export function useInspectionCompartmentRepository(): InspectionCompartmentRepositoryClient { return makeRepositoryProxy<InspectionCompartmentRepositoryClient>('mws::InspectionCompartmentRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useInspectionCompartmentRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const inspectionCompartmentRepository = useInspectionCompartmentRepository();

type InspectionDrawingRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<InspectionDrawingRepository>;
export function useInspectionDrawingRepository(): InspectionDrawingRepositoryClient { return makeRepositoryProxy<InspectionDrawingRepositoryClient>('mws::InspectionDrawingRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useInspectionDrawingRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const inspectionDrawingRepository = useInspectionDrawingRepository();

type NcrRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<NcrRepository>;
export function useNcrRepository(): NcrRepositoryClient { return makeRepositoryProxy<NcrRepositoryClient>('mws::NcrRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useNcrRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const ncrRepository = useNcrRepository();

type NcrResponsibleRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<NcrResponsibleRepository>;
export function useNcrResponsibleRepository(): NcrResponsibleRepositoryClient { return makeRepositoryProxy<NcrResponsibleRepositoryClient>('mws::NcrResponsibleRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useNcrResponsibleRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const ncrResponsibleRepository = useNcrResponsibleRepository();

type ProtocolRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<ProtocolRepository>;
export function useProtocolRepository(): ProtocolRepositoryClient { return makeRepositoryProxy<ProtocolRepositoryClient>('mws::ProtocolRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useProtocolRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const protocolRepository = useProtocolRepository();

type AcceptanceActRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<AcceptanceActRepository>;
export function useAcceptanceActRepository(): AcceptanceActRepositoryClient { return makeRepositoryProxy<AcceptanceActRepositoryClient>('mws::AcceptanceActRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useAcceptanceActRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const acceptanceActRepository = useAcceptanceActRepository();

type CertificateRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<CertificateRepository>;
export function useCertificateRepository(): CertificateRepositoryClient { return makeRepositoryProxy<CertificateRepositoryClient>('mws::CertificateRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useCertificateRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const certificateRepository = useCertificateRepository();

type CertificateObjectRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<CertificateObjectRepository>;
export function useCertificateObjectRepository(): CertificateObjectRepositoryClient { return makeRepositoryProxy<CertificateObjectRepositoryClient>('mws::CertificateObjectRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useCertificateObjectRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const certificateObjectRepository = useCertificateObjectRepository();

type ReportingWeekRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<ReportingWeekRepository>;
export function useReportingWeekRepository(): ReportingWeekRepositoryClient { return makeRepositoryProxy<ReportingWeekRepositoryClient>('mws::ReportingWeekRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useReportingWeekRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const reportingWeekRepository = useReportingWeekRepository();

type ReportRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<ReportRepository>;
export function useReportRepository(): ReportRepositoryClient { return makeRepositoryProxy<ReportRepositoryClient>('mws::ReportRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useReportRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const reportRepository = useReportRepository();

type ReportPublicationRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<ReportPublicationRepository>;
export function useReportPublicationRepository(): ReportPublicationRepositoryClient { return makeRepositoryProxy<ReportPublicationRepositoryClient>('mws::ReportPublicationRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useReportPublicationRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const reportPublicationRepository = useReportPublicationRepository();

type RequestImportRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<RequestImportRepository>;
export function useRequestImportRepository(): RequestImportRepositoryClient { return makeRepositoryProxy<RequestImportRepositoryClient>('mws::RequestImportRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useRequestImportRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const requestImportRepository = useRequestImportRepository();

type PlanImportRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<PlanImportRepository>;
export function usePlanImportRepository(): PlanImportRepositoryClient { return makeRepositoryProxy<PlanImportRepositoryClient>('mws::PlanImportRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте usePlanImportRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const planImportRepository = usePlanImportRepository();

type ShipyardWeekPlanRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<ShipyardWeekPlanRepository>;
export function useShipyardWeekPlanRepository(): ShipyardWeekPlanRepositoryClient { return makeRepositoryProxy<ShipyardWeekPlanRepositoryClient>('mws::ShipyardWeekPlanRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useShipyardWeekPlanRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const shipyardWeekPlanRepository = useShipyardWeekPlanRepository();

type RpImportRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<RpImportRepository>;
export function useRpImportRepository(): RpImportRepositoryClient { return makeRepositoryProxy<RpImportRepositoryClient>('mws::RpImportRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useRpImportRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const rpImportRepository = useRpImportRepository();

type RpSnapshotRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<RpSnapshotRepository>;
export function useRpSnapshotRepository(): RpSnapshotRepositoryClient { return makeRepositoryProxy<RpSnapshotRepositoryClient>('mws::RpSnapshotRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useRpSnapshotRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const rpSnapshotRepository = useRpSnapshotRepository();

type RpPlanRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<RpPlanRepository>;
export function useRpPlanRepository(): RpPlanRepositoryClient { return makeRepositoryProxy<RpPlanRepositoryClient>('mws::RpPlanRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useRpPlanRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const rpPlanRepository = useRpPlanRepository();

type RpRowRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<RpRowRepository>;
export function useRpRowRepository(): RpRowRepositoryClient { return makeRepositoryProxy<RpRowRepositoryClient>('mws::RpRowRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useRpRowRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const rpRowRepository = useRpRowRepository();

type RpTranslationRepositoryClient = import('@ayocore/platform/server/rpc/types').AwaitableRpcClient<RpTranslationRepository>;
export function useRpTranslationRepository(): RpTranslationRepositoryClient { return makeRepositoryProxy<RpTranslationRepositoryClient>('mws::RpTranslationRepository', { terminalMethods: TERMINAL_METHODS }); }
/**
 * ВРЕМЕННЫЙ алиас для обратной совместимости.
 * Используйте useRpTranslationRepository() внутри React-компонентов.
 * Этот экспорт будет удалён позже.
 */
export const rpTranslationRepository = useRpTranslationRepository();

type parseRpSnapshotType = typeof import('../server/functions/parseRpSnapshot').parseRpSnapshot;
export const parseRpSnapshot: RpcFunctionClient<parseRpSnapshotType> = makeFunctionProxy<parseRpSnapshotType>('mws::parseRpSnapshot');

type translateRpDictionaryType = typeof import('../server/functions/translateRpDictionary').translateRpDictionary;
export const translateRpDictionary: RpcFunctionClient<translateRpDictionaryType> = makeFunctionProxy<translateRpDictionaryType>('mws::translateRpDictionary');

type ingestSectionsType = typeof import('../server/functions/ingestSections').ingestSections;
export const ingestSections: RpcFunctionClient<ingestSectionsType> = makeFunctionProxy<ingestSectionsType>('mws::ingestSections');

type ingestRollingPlanSnapshotType = typeof import('../server/functions/ingestRollingPlanSnapshot').ingestRollingPlanSnapshot;
export const ingestRollingPlanSnapshot: RpcFunctionClient<ingestRollingPlanSnapshotType> = makeFunctionProxy<ingestRollingPlanSnapshotType>('mws::ingestRollingPlanSnapshot');

type getProjectDriftType = typeof import('../server/functions/getProjectDrift').getProjectDrift;
export const getProjectDrift: RpcFunctionClient<getProjectDriftType> = makeFunctionProxy<getProjectDriftType>('mws::getProjectDrift');

type getInspectionProgressType = typeof import('../server/functions/getInspectionProgress').getInspectionProgress;
export const getInspectionProgress: RpcFunctionClient<getInspectionProgressType> = makeFunctionProxy<getInspectionProgressType>('mws::getInspectionProgress');

type getInspectionProgressDetailsType = typeof import('../server/functions/getInspectionProgressDetails').getInspectionProgressDetails;
export const getInspectionProgressDetails: RpcFunctionClient<getInspectionProgressDetailsType> = makeFunctionProxy<getInspectionProgressDetailsType>('mws::getInspectionProgressDetails');

type getUnassignedInspectionProgressType = typeof import('../server/functions/getUnassignedInspectionProgress').getUnassignedInspectionProgress;
export const getUnassignedInspectionProgress: RpcFunctionClient<getUnassignedInspectionProgressType> = makeFunctionProxy<getUnassignedInspectionProgressType>('mws::getUnassignedInspectionProgress');

type getVolumeMetricsType = typeof import('../server/functions/getVolumeMetrics').getVolumeMetrics;
export const getVolumeMetrics: RpcFunctionClient<getVolumeMetricsType> = makeFunctionProxy<getVolumeMetricsType>('mws::getVolumeMetrics');

type getRollingPlanMatrixType = typeof import('../server/functions/getRollingPlanMatrix').getRollingPlanMatrix;
export const getRollingPlanMatrix: RpcFunctionClient<getRollingPlanMatrixType> = makeFunctionProxy<getRollingPlanMatrixType>('mws::getRollingPlanMatrix');

type submitInspectionResultType = typeof import('../server/functions/submitInspectionResult').submitInspectionResult;
export const submitInspectionResult: RpcFunctionClient<submitInspectionResultType> = makeFunctionProxy<submitInspectionResultType>('mws::submitInspectionResult');

type cancelInspectionType = typeof import('../server/functions/cancelInspection').cancelInspection;
export const cancelInspection: RpcFunctionClient<cancelInspectionType> = makeFunctionProxy<cancelInspectionType>('mws::cancelInspection');

type addRpRowsToWeekPlanType = typeof import('../server/functions/addRpRowsToWeekPlan').addRpRowsToWeekPlan;
export const addRpRowsToWeekPlan: RpcFunctionClient<addRpRowsToWeekPlanType> = makeFunctionProxy<addRpRowsToWeekPlanType>('mws::addRpRowsToWeekPlan');

type saveInspectionWithSectionsType = typeof import('../server/functions/saveInspectionWithSections').saveInspectionWithSections;
export const saveInspectionWithSections: RpcFunctionClient<saveInspectionWithSectionsType> = makeFunctionProxy<saveInspectionWithSectionsType>('mws::saveInspectionWithSections');

type groupInspectionsType = typeof import('../server/functions/groupInspections').groupInspections;
export const groupInspections: RpcFunctionClient<groupInspectionsType> = makeFunctionProxy<groupInspectionsType>('mws::groupInspections');

type saveInspectionCommentType = typeof import('../server/functions/saveInspectionComment').saveInspectionComment;
export const saveInspectionComment: RpcFunctionClient<saveInspectionCommentType> = makeFunctionProxy<saveInspectionCommentType>('mws::saveInspectionComment');

type saveInspectionReportQuantitiesType = typeof import('../server/functions/saveInspectionReportQuantities').saveInspectionReportQuantities;
export const saveInspectionReportQuantities: RpcFunctionClient<saveInspectionReportQuantitiesType> = makeFunctionProxy<saveInspectionReportQuantitiesType>('mws::saveInspectionReportQuantities');

type resolveInspectionGroupContextType = typeof import('../server/functions/resolveInspectionGroupContext').resolveInspectionGroupContext;
export const resolveInspectionGroupContext: RpcFunctionClient<resolveInspectionGroupContextType> = makeFunctionProxy<resolveInspectionGroupContextType>('mws::resolveInspectionGroupContext');

type ungroupInspectionsType = typeof import('../server/functions/ungroupInspections').ungroupInspections;
export const ungroupInspections: RpcFunctionClient<ungroupInspectionsType> = makeFunctionProxy<ungroupInspectionsType>('mws::ungroupInspections');

type saveSpoolTrackingType = typeof import('../server/functions/saveSpoolTracking').saveSpoolTracking;
export const saveSpoolTracking: RpcFunctionClient<saveSpoolTrackingType> = makeFunctionProxy<saveSpoolTrackingType>('mws::saveSpoolTracking');

type saveEquipmentTrackingType = typeof import('../server/functions/saveEquipmentTracking').saveEquipmentTracking;
export const saveEquipmentTracking: RpcFunctionClient<saveEquipmentTrackingType> = makeFunctionProxy<saveEquipmentTrackingType>('mws::saveEquipmentTracking');

type saveMechTrackingType = typeof import('../server/functions/saveMechTracking').saveMechTracking;
export const saveMechTracking: RpcFunctionClient<saveMechTrackingType> = makeFunctionProxy<saveMechTrackingType>('mws::saveMechTracking');

type saveNcrWithResponsiblesType = typeof import('../server/functions/saveNcrWithResponsibles').saveNcrWithResponsibles;
export const saveNcrWithResponsibles: RpcFunctionClient<saveNcrWithResponsiblesType> = makeFunctionProxy<saveNcrWithResponsiblesType>('mws::saveNcrWithResponsibles');

type saveCertificateType = typeof import('../server/functions/saveCertificate').saveCertificate;
export const saveCertificate: RpcFunctionClient<saveCertificateType> = makeFunctionProxy<saveCertificateType>('mws::saveCertificate');

type getInspectionCertificateDefaultsType = typeof import('../server/functions/getInspectionCertificateDefaults').getInspectionCertificateDefaults;
export const getInspectionCertificateDefaults: RpcFunctionClient<getInspectionCertificateDefaultsType> = makeFunctionProxy<getInspectionCertificateDefaultsType>('mws::getInspectionCertificateDefaults');

type ensureWeeksRangeType = typeof import('../server/functions/ensureWeeksRange').ensureWeeksRange;
export const ensureWeeksRange: RpcFunctionClient<ensureWeeksRangeType> = makeFunctionProxy<ensureWeeksRangeType>('mws::ensureWeeksRange');

type applyInspectionPhotoTemplateType = typeof import('../server/functions/applyInspectionPhotoTemplate').applyInspectionPhotoTemplate;
export const applyInspectionPhotoTemplate: RpcFunctionClient<applyInspectionPhotoTemplateType> = makeFunctionProxy<applyInspectionPhotoTemplateType>('mws::applyInspectionPhotoTemplate');

type ensureInspectionDriveFolderType = typeof import('../server/functions/ensureInspectionDriveFolder').ensureInspectionDriveFolder;
export const ensureInspectionDriveFolder: RpcFunctionClient<ensureInspectionDriveFolderType> = makeFunctionProxy<ensureInspectionDriveFolderType>('mws::ensureInspectionDriveFolder');

type applyNcrPhotoTemplateType = typeof import('../server/functions/applyNcrPhotoTemplate').applyNcrPhotoTemplate;
export const applyNcrPhotoTemplate: RpcFunctionClient<applyNcrPhotoTemplateType> = makeFunctionProxy<applyNcrPhotoTemplateType>('mws::applyNcrPhotoTemplate');

type attachInspectionFilesToNcrType = typeof import('../server/functions/attachInspectionFilesToNcr').attachInspectionFilesToNcr;
export const attachInspectionFilesToNcr: RpcFunctionClient<attachInspectionFilesToNcrType> = makeFunctionProxy<attachInspectionFilesToNcrType>('mws::attachInspectionFilesToNcr');

type translateNcrTextType = typeof import('../server/functions/translateNcrText').translateNcrText;
export const translateNcrText: RpcFunctionClient<translateNcrTextType> = makeFunctionProxy<translateNcrTextType>('mws::translateNcrText');

type recognizeProtocolType = typeof import('../server/functions/recognizeProtocol').recognizeProtocol;
export const recognizeProtocol: RpcFunctionClient<recognizeProtocolType> = makeFunctionProxy<recognizeProtocolType>('mws::recognizeProtocol');

type buildWeeklyReportDataType = typeof import('../server/functions/buildWeeklyReportData').buildWeeklyReportData;
export const buildWeeklyReportData: RpcFunctionClient<buildWeeklyReportDataType> = makeFunctionProxy<buildWeeklyReportDataType>('mws::buildWeeklyReportData');

type createWeeklyReportType = typeof import('../server/functions/createWeeklyReport').createWeeklyReport;
export const createWeeklyReport: RpcFunctionClient<createWeeklyReportType> = makeFunctionProxy<createWeeklyReportType>('mws::createWeeklyReport');

type generateWeeklyReportType = typeof import('../server/functions/generateWeeklyReport').generateWeeklyReport;
export const generateWeeklyReport: RpcFunctionClient<generateWeeklyReportType> = makeFunctionProxy<generateWeeklyReportType>('mws::generateWeeklyReport');

type ensureReportingWeekType = typeof import('../server/functions/ensureReportingWeek').ensureReportingWeek;
export const ensureReportingWeek: RpcFunctionClient<ensureReportingWeekType> = makeFunctionProxy<ensureReportingWeekType>('mws::ensureReportingWeek');

type getProjectWelcomeStatsType = typeof import('../server/functions/getProjectWelcomeStats').getProjectWelcomeStats;
export const getProjectWelcomeStats: RpcFunctionClient<getProjectWelcomeStatsType> = makeFunctionProxy<getProjectWelcomeStatsType>('mws::getProjectWelcomeStats');

type syncDriveFoldersType = typeof import('../server/functions/syncDriveFolders').syncDriveFolders;
export const syncDriveFolders: RpcFunctionClient<syncDriveFoldersType> = makeFunctionProxy<syncDriveFoldersType>('mws::syncDriveFolders');

type getWeekInspectionPhotosType = typeof import('../server/functions/getWeekInspectionPhotos').getWeekInspectionPhotos;
export const getWeekInspectionPhotos: RpcFunctionClient<getWeekInspectionPhotosType> = makeFunctionProxy<getWeekInspectionPhotosType>('mws::getWeekInspectionPhotos');

type submitWeekRequestType = typeof import('../server/functions/submitWeekRequest').submitWeekRequest;
export const submitWeekRequest: RpcFunctionClient<submitWeekRequestType> = makeFunctionProxy<submitWeekRequestType>('mws::submitWeekRequest');

type parseRequestImportType = typeof import('../server/functions/parseRequestImport').parseRequestImport;
export const parseRequestImport: RpcFunctionClient<parseRequestImportType> = makeFunctionProxy<parseRequestImportType>('mws::parseRequestImport');

type listRequestSheetsType = typeof import('../server/functions/listRequestSheets').listRequestSheets;
export const listRequestSheets: RpcFunctionClient<listRequestSheetsType> = makeFunctionProxy<listRequestSheetsType>('mws::listRequestSheets');

type applyRequestImportType = typeof import('../server/functions/applyRequestImport').applyRequestImport;
export const applyRequestImport: RpcFunctionClient<applyRequestImportType> = makeFunctionProxy<applyRequestImportType>('mws::applyRequestImport');

type deleteRequestImportInspectionType = typeof import('../server/functions/deleteRequestImportInspection').deleteRequestImportInspection;
export const deleteRequestImportInspection: RpcFunctionClient<deleteRequestImportInspectionType> = makeFunctionProxy<deleteRequestImportInspectionType>('mws::deleteRequestImportInspection');

type analyzeRequestRowType = typeof import('../server/functions/analyzeRequestRow').analyzeRequestRow;
export const analyzeRequestRow: RpcFunctionClient<analyzeRequestRowType> = makeFunctionProxy<analyzeRequestRowType>('mws::analyzeRequestRow');

type registerWeekRequestFilesType = typeof import('../server/functions/registerWeekRequestFiles').registerWeekRequestFiles;
export const registerWeekRequestFiles: RpcFunctionClient<registerWeekRequestFilesType> = makeFunctionProxy<registerWeekRequestFilesType>('mws::registerWeekRequestFiles');

type parseShipyardWeekPlanType = typeof import('../server/functions/parseShipyardWeekPlan').parseShipyardWeekPlan;
export const parseShipyardWeekPlan: RpcFunctionClient<parseShipyardWeekPlanType> = makeFunctionProxy<parseShipyardWeekPlanType>('mws::parseShipyardWeekPlan');

type registerWeekPlanFilesType = typeof import('../server/functions/registerWeekPlanFiles').registerWeekPlanFiles;
export const registerWeekPlanFiles: RpcFunctionClient<registerWeekPlanFilesType> = makeFunctionProxy<registerWeekPlanFilesType>('mws::registerWeekPlanFiles');

type parseRpImportType = typeof import('../server/functions/parseRpImport').parseRpImport;
export const parseRpImport: RpcFunctionClient<parseRpImportType> = makeFunctionProxy<parseRpImportType>('mws::parseRpImport');

type registerWeekRpFilesType = typeof import('../server/functions/registerWeekRpFiles').registerWeekRpFiles;
export const registerWeekRpFiles: RpcFunctionClient<registerWeekRpFilesType> = makeFunctionProxy<registerWeekRpFilesType>('mws::registerWeekRpFiles');

type finalizeReportType = typeof import('../server/functions/finalizeReport').finalizeReport;
export const finalizeReport: RpcFunctionClient<finalizeReportType> = makeFunctionProxy<finalizeReportType>('mws::finalizeReport');

type reopenReportType = typeof import('../server/functions/reopenReport').reopenReport;
export const reopenReport: RpcFunctionClient<reopenReportType> = makeFunctionProxy<reopenReportType>('mws::reopenReport');

type composeProgressNoteType = typeof import('../server/functions/composeProgressNote').composeProgressNote;
export const composeProgressNote: RpcFunctionClient<composeProgressNoteType> = makeFunctionProxy<composeProgressNoteType>('mws::composeProgressNote');

type linkStagesToProjectTypeType = typeof import('../server/functions/linkStagesToProjectType').linkStagesToProjectType;
export const linkStagesToProjectType: RpcFunctionClient<linkStagesToProjectTypeType> = makeFunctionProxy<linkStagesToProjectTypeType>('mws::linkStagesToProjectType');

type linkWorkTypesToProjectTypeType = typeof import('../server/functions/linkWorkTypesToProjectType').linkWorkTypesToProjectType;
export const linkWorkTypesToProjectType: RpcFunctionClient<linkWorkTypesToProjectTypeType> = makeFunctionProxy<linkWorkTypesToProjectTypeType>('mws::linkWorkTypesToProjectType');

type createAndLinkStageType = typeof import('../server/functions/createAndLinkStage').createAndLinkStage;
export const createAndLinkStage: RpcFunctionClient<createAndLinkStageType> = makeFunctionProxy<createAndLinkStageType>('mws::createAndLinkStage');

type createAndLinkWorkTypeType = typeof import('../server/functions/createAndLinkWorkType').createAndLinkWorkType;
export const createAndLinkWorkType: RpcFunctionClient<createAndLinkWorkTypeType> = makeFunctionProxy<createAndLinkWorkTypeType>('mws::createAndLinkWorkType');

type unlinkStageFromProjectTypeType = typeof import('../server/functions/unlinkStageFromProjectType').unlinkStageFromProjectType;
export const unlinkStageFromProjectType: RpcFunctionClient<unlinkStageFromProjectTypeType> = makeFunctionProxy<unlinkStageFromProjectTypeType>('mws::unlinkStageFromProjectType');

type unlinkWorkTypeFromProjectTypeType = typeof import('../server/functions/unlinkWorkTypeFromProjectType').unlinkWorkTypeFromProjectType;
export const unlinkWorkTypeFromProjectType: RpcFunctionClient<unlinkWorkTypeFromProjectTypeType> = makeFunctionProxy<unlinkWorkTypeFromProjectTypeType>('mws::unlinkWorkTypeFromProjectType');
